import { render, staticRenderFns } from "./GFrunpayslips.vue?vue&type=template&id=d96e0038"
import script from "./GFrunpayslips.vue?vue&type=script&lang=js"
export * from "./GFrunpayslips.vue?vue&type=script&lang=js"
import style0 from "./GFrunpayslips.vue?vue&type=style&index=0&id=d96e0038&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports